import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
const formatCommentsRow = (commentAggregates) => {
    const commentCell = { richText: [] };
    commentAggregates.forEach(comment => {
        const timestamp = getDateFromISOToLocal(comment.date);
        commentCell.richText.push({
            font: { bold: true },
            text: `${comment.user.name} • ${timestamp}`,
        });
        let privilegeText = '';
        for (const privilegeGroup of comment.privilegeGroups || []) {
            if (privilegeText === '') {
                privilegeText = ` - ${privilegeGroup.displayName}`;
            }
            else {
                privilegeText += `, ${privilegeGroup.displayName}`;
            }
        }
        commentCell.richText.push({
            font: { italic: true },
            text: `${privilegeText}\r\n`,
        });
        commentCell.richText.push({
            font: {},
            text: `${comment.text}\r\n\r\n`,
        });
    });
    return commentCell;
};
const addTopLevelClassificationRow = (worksheet, newExcelRows, totalColumns) => {
    newExcelRows.forEach(newExcelRow => {
        const addedRow = worksheet.addRow(newExcelRow);
        for (let i = 1; i <= totalColumns; i++) {
            const cell = addedRow.getCell(i);
            cell.alignment = { wrapText: true, vertical: 'top' };
        }
    });
};
const addClassificationDivider = (worksheet, totalColumns) => {
    const greyRow = worksheet.addRow([]);
    for (let i = 1; i <= totalColumns; i++) {
        const cell = greyRow.getCell(i);
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '808080' },
        };
    }
};
export { formatCommentsRow, addTopLevelClassificationRow, addClassificationDivider, };
